<template>
  <div class="configNetPage">
    <!-- 第一部分: 基础信息 -->
    <div class="section-box">
      <ul class="base-info">
        <li v-for="item in baseMsg" :key="item.key">
          <span class="label">{{ $t(item.text) }}：</span>
          <span class="value">
            <template v-if="item.key === 'url'">
              {{ urlFn() }}
              <!-- <span v-if="$attrs['sensorWay'] === 'bind' || $attrs['sensorWay'] === 'stop'">
                            {{
                                $attrs.rowData.scopeName + '/' + $attrs.rowData.sceneName
                            }}
                            </span>
                        <span v-else>{{ $attrs.rowData.scopeName }}</span> -->
            </template>
            <template v-else-if="item.key === 'type' || item.key === 'status'">
              {{ textChange(item.key) }}
            </template>
            <template v-else>
              <i
                v-show="item.key === 'tag_id'"
                v-icon="['equiStatusConvert', $attrs.rowData['status']]"
              ></i>
              {{ $attrs.rowData[item.key] }}
            </template>
          </span>
        </li>
      </ul>
    </div>
    <!-- 第二部分: 配置参数 (由 ruleChildren 组件渲染, 包含 Command section-box) -->
    <ruleChildren
      v-bind="$attrs"
      :sensorConfig="sensorConfig"
      @listFn="listFn"
      @getList="getList"
    />
    <!-- 列表 -->
    <!--    <div class="list">-->
    <!--      <div class="listPage" v-for="item in listArray" :key="item.id">-->
    <!--        <span>{{ $timetransition(item['log_time']) }}</span>-->
    <!--        &lt;!&ndash; 只能输网络参数 &ndash;&gt;-->
    <!--        <span>{{ $t('integration.escalation_rules') }}</span>-->
    <!--        <span>{{ configFn(item['step_code']) }}</span>-->
    <!--        <el-button-->
    <!--          type="text"-->
    <!--          size="small"-->
    <!--          :title="$t('public.details')"-->
    <!--          icon="el-icon-tickets"-->
    <!--          @click="configDetailFn(item)"-->
    <!--        ></el-button>-->
    <!--      </div>-->

    <!--    </div>-->
    <!-- 第四部分: 配置列表 -->
    <div class="section-box" v-if="listArray.length">
      <ConfigList :sensor-info="$attrs.rowData" :list="listArray" :configStatus="configStatus"></ConfigList>
    </div>

    <!-- 命令详情 -->
    <CmdDialog
      :isShow.sync="isShow"
      v-bind="$attrs"
      :title="title"
      :cmdObj="cmdObj"
      ref="configLogDia"
    />
  </div>
</template>

<script>
import ruleChildren from './children/ruleChileren.vue'
import { sensorGetDetailConfig } from '@/api/modules/sensor'
import { configStatusConvert, configStep } from '@/utils/convert'
import { sensorType } from '@/utils/dict/sensor'
import CmdDialog from '@/pages/equipment/sensor/components/sensor/cionfig/children/CmdDialog.vue'
import ConfigList from '@/pages/equipment/sensor/components/sensor/cionfig/children/ConfigList.vue'

export default {
  computed: {
    configStatus () {
      // 默认已配置
      if (this.sensorConfig) {
        return this.sensorConfig.status
      } else {
        return 2
      }
    }
  },
  components: {
    ConfigList,
    ruleChildren,
    CmdDialog
  },
  data () {
    return {
      dioForm: {},
      baseMsg: [
        {
          key: 'url',
          text: 'public.belong'
        },
        {
          key: 'tag_id',
          text: 'device.sensor_code'
        },
        {
          key: 'status',
          text: 'device.config_status'
        },
        {
          key: 'carrierName',
          text: 'public.carrier'
        },
        {
          key: 'type',
          text: 'public.type'
        },
        {
          key: 'description',
          text: 'public.table_desc'
        }
      ],
      listArray: [],
      isShow: false,
      title: '',
      cmdObj: {},
      appConfig: null,
      sensorConfig: null
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      if (
        this.$attrs.sensorWay === 'unknown' ||
        this.$attrs.sensorWay === 'unbind'
      ) {
        this.baseMsg.splice(3, 1)
      } else {
      }
      sensorGetDetailConfig(
        {
          sensorId: this.$attrs.rowData.id,
          tagId: this.$attrs.rowData.tagId
        },
        'app'
      ).then(({ result }) => {
        this.appConfig = result.appConfig
        this.sensorConfig = result.sensorConfig
        if (this.sensorConfig) {
          this.$emit('onConfigStatusChange', this.sensorConfig.status)
        }
      })
    },
    urlFn () {
      let url = this.$attrs.rowData.scopeName
      if (this.$attrs.rowData.sceneName) {
        url += '/' + this.$attrs.rowData.sceneName
      }
      if (this.$attrs.rowData.carrierName) {
        url += '/' + this.$attrs.rowData.carrierName
      }
      return url
    },
    textChange (key) {
      if (key === 'status') {
        return this.$t(configStatusConvert(this.configStatus).title)
      } else if (key === 'type') {
        if (!this.$attrs.rowData[key]) {
          return
        }

        return this.$t(sensorType[this.$attrs.rowData[key]].title)
      } else {
        return this.rowData[key]
      }
    },
    statusFn (key) {
      return key === 1 ? this.$t('public.online') : this.$t('public.offline')
    },
    configFn (value) {
      return this.$t(configStep[value].title)
    },
    listFn (array) {
      this.listArray = array
    }
  }
}
</script>

<style lang="scss" scoped>
.configNetPage {
  .section-box {
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-left: 3px solid var(--primary-color, #409eff);
    border-radius: 4px;
    padding: 14px 20px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .base-info {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;

    li {
      display: contents;
    }

    .label {
      text-align: right;
      line-height: 40px;
      color: #606266;
      font-size: 14px;
    }

    .value {
      line-height: 40px;
      color: #606266;
      font-size: 14px;
    }
  }

  .list {
    max-height: 200px;
    overflow: auto;
  }

  .listPage {
    height: 40px;
    width: 100%;
    margin-top: 15px;
    padding: 0 15px;
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
